export const filmBoxRef = document.querySelector('.js-films-list');
export const formRef = document.querySelector('.search__form');
export const listButton = document.querySelector('.buttons__list');
export const queueButton = document.querySelector('.js-queue');
export const genreInfo =
  '{"genres":[{"id":28,"name":"Action"},{"id":12,"name":"Adventure"},{"id":16,"name":"Animation"},{"id":35,"name":"Comedy"},{"id":80,"name":"Crime"},{"id":99,"name":"Documentary"},{"id":18,"name":"Drama"},{"id":10751,"name":"Family"},{"id":14,"name":"Fantasy"},{"id":36,"name":"History"},{"id":27,"name":"Horror"},{"id":10402,"name":"Music"},{"id":9648,"name":"Mystery"},{"id":10749,"name":"Romance"},{"id":878,"name":"Science Fiction"},{"id":10770,"name":"TV Movie"},{"id":53,"name":"Thriller"},{"id":10752,"name":"War"},{"id":37,"name":"Western"},{"id":9999,"name":"Other"}]}';
export const firebaseConfig = {
  apiKey: 'AIzaSyAjQPJnYi1aRc8VFSsfJnmKhUmbl7irFnM',
  authDomain: 'filmoteka-377516.firebaseapp.com',
  databaseURL: 'https://filmoteka-377516-default-rtdb.firebaseio.com',
  projectId: 'filmoteka-377516',
  storageBucket: 'filmoteka-377516.appspot.com',
  messagingSenderId: '794274389144',
  appId: '1:794274389144:web:7484dd766f3d32da9f44ed',
  measurementId: 'G-C2FX86EHMV',
};
